module.exports = __webpack_public_path__ + "img/il-item-not-found.3833cb9.svg";